import { render, staticRenderFns } from "./IssueLogEmpty.vue?vue&type=template&id=7b9c3ba7&"
import script from "./IssueLogEmpty.vue?vue&type=script&lang=ts&"
export * from "./IssueLogEmpty.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports